import script from "./xyxw.vue?vue&type=script&setup=true&lang=js"
export * from "./xyxw.vue?vue&type=script&setup=true&lang=js"

import "./xyxw.vue?vue&type=style&index=0&id=17f76177&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17f76177"]])

export default __exports__